var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-table-cell creation-date-cell" }, [
    _c("div", { staticClass: "c-table-cell__wrapper" }, [
      _c(
        "div",
        { staticClass: "creation-date-cell-icon" },
        [
          _c("candidates-status-icon", {
            attrs: {
              status: _vm.data.candidateState.value,
              "scheduled-date-time": _vm.data.candidateState.scheduledDateTime,
            },
          }),
        ],
        1
      ),
      _c("div", [_vm._v(" " + _vm._s(_vm.data.value) + " ")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }